'use client';
import {Logo} from "@web-libs/features/branding/logo/ui/logo";
import {Button} from "@web-libs/ui/ui-components/buttons/button";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {useAuth} from "@web-libs/features/auth/main/application/use-auth.concern";
import {routes} from "@web-app/[lang]/[tenant]/[institution]/routes-institution";
import cssStyles from "@web-libs/ui/layout-components/common-page-ui/structural-elements/public-header.module.css"
import {mergeClassNames} from "@web-libs/util/class-names/class-names";
import React from "react";
import {LanguageSelector} from "@web-libs/ui/ui-components/language-selector/language-selector";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";

export const PublicHeader = ({className}:{className:string}) => {

    const router = useTageaRouter()
    const auth = useAuth()

    const navigateToRegister = () => {
        router.push(routes.registration)
    }

    const navigateToLogin = () => {
        auth.requestLogin()
    }
    const dict = useDictionaryContext()

    return (
        <div className={mergeClassNames(className,cssStyles.wrapper)}>
            <div style={{display: "flex"}}>
               <div className={cssStyles.logo}><Logo fitParent/></div>
                <LanguageSelector style={{alignItems: "center"}} background={"lightShade"}/>
            </div>
            <div style={{display:"flex", alignItems:"center"}}>
                <Button inline style={{marginRight: 20}} compact={false} text={dict.register} color={"dark"} onClick={() => {
                    navigateToRegister()
                }}/>
                <Button inline compact={false} text={dict.logIn} color={"primary"} onClick={() => {
                    navigateToLogin()
                }}/>
            </div>
        </div>
    )
}
